import styles from "./TileContainer.module.css"

const TileContainer = ({children}) =>{
    return <div className={styles.displayDataContainer}>{children}</div>
}

export default TileContainer;